import api from '@/api/api'
import router from '@/router/index'
import { normalize, schema } from 'normalizr'
import actividadesProfesionales, { actividadProfesional } from './actividadesProfesionales/store'
import estadosCiviles, { estadoCivil } from './estadosCiviles/store'
import nacionalidades, { nacionalidad } from './nacionalidades/store'
import origenFondos, { origenFondo } from './origenFondos/store'
import paises, { pais } from './paises/store'
import profesiones, { profesion } from './profesiones/store'
import propositosContractuales, { propositoContractual } from './propositosContractuales/store'
import provincias, { provincia } from './provincias/store'
import tiposVias, { tipoVia } from './tiposVias/store'
import tiposDocumentos, { tipoDocumento } from './tiposDocumentos/store'
import prefijos, { prefijo } from './prefijos/store'
import roles from './roles/store'

export const maestros = new schema.Entity('maestros', {
  'actividadesProfesionales': [actividadProfesional],
  'estadosCiviles': [estadoCivil],
  'nacionalidades': [nacionalidad],
  'origenFondos': [origenFondo],
  'paises': [pais],
  'profesiones': [profesion],
  'propositosContractuales': [propositoContractual],
  'provincias': [provincia],
  'tiposVias': [tipoVia],
  'prefijos': [prefijo]
})

export default {
  namespaced: true,
  modules: {
    actividadesProfesionales,
    estadosCiviles,
    nacionalidades,
    origenFondos,
    paises,
    profesiones,
    propositosContractuales,
    provincias,
    tiposVias,
    tiposDocumentos,
    roles,
    prefijos
  },
  state: {
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    }
  },
  actions: {
    load ({ commit, dispatch }) { // Devuelve todos los maestros
      return new Promise((resolve, reject) => {
        api.get('/maestros/get')
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, maestros)
              commit('maestros/actividadesProfesionales/setAll', normalizedData.entities.actividadProfesional, {root: true})
              commit('maestros/estadosCiviles/setAll', normalizedData.entities.estadoCivil, {root: true})
              commit('maestros/nacionalidades/setAll', normalizedData.entities.nacionalidad, {root: true})
              commit('maestros/origenFondos/setAll', normalizedData.entities.origenFondo, {root: true})
              commit('maestros/paises/setAll', normalizedData.entities.pais, {root: true})
              commit('maestros/profesiones/setAll', normalizedData.entities.profesion, {root: true})
              commit('maestros/propositosContractuales/setAll', normalizedData.entities.propositoContractual, {root: true})
              commit('maestros/provincias/setAll', normalizedData.entities.provincia, {root: true})
              commit('maestros/tiposVias/setAll', normalizedData.entities.tipoVia, {root: true})
              commit('maestros/prefijos/setAll', normalizedData.entities.prefijo, {root: true})
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    loadTiposDocumentos ({ commit, dispatch }) { // Devuelve los tipos de documentos
      return new Promise((resolve, reject) => {
        api.get('/maestros/get_tipos_documento_id')
          .then(response => {
            if (response.data.result.ok) {
              let normalizedData = normalize(response.data.result.data.data, [tipoDocumento])
              commit('maestros/tiposDocumentos/setAll', normalizedData.entities.tipoDocumento, {root: true})
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/maestros/store.js